import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { AxiosError } from 'axios';

export type VerificationRequest = { email: string };

async function verifyEmail(req: VerificationRequest): Promise<void> {
    const { data } = await api.post(`/email-verification`, req);
    return data;
}

export function useVerifyEmail(): UseMutationResult<void, AxiosError, VerificationRequest, unknown> {
    return useMutation((req) => verifyEmail(req), {});
}
